/* QUANTICA · Bloque de compra: tramos de cantidad, plan y pestanas.

   Mejora progresiva. Sin este archivo el bloque sigue sirviendo: hay un
   input de cantidad real, el formulario de Shopify agrega al carrito y las
   pestanas se ven todas, una debajo de la otra. */

(function () {
  var money = function (cents, fmt) {
    var n = (cents / 100).toFixed(2);
    if (fmt && fmt.indexOf('{{') !== -1) {
      return fmt.replace(/\{\{\s*amount[^}]*\}\}/, n);
    }
    return '$' + n;
  };

  if (!customElements.get('q-buybox')) customElements.define('q-buybox', class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-qty-input]');
      this.deal = this.querySelector('[data-deal]');
      this.dealWas = this.querySelector('[data-deal-was]');
      this.dealNow = this.querySelector('[data-deal-now]');
      this.dealUnit = this.querySelector('[data-deal-unit]');
      this.dealSave = this.querySelector('[data-deal-save]');
      this.nudge = this.querySelector('[data-nudge]');
      this.tiers = Array.prototype.slice.call(this.querySelectorAll('[data-tier]'));
      this.freq = this.querySelector('[data-freq]');
      this.note = this.querySelector('[data-cta-note]');
      this.cta = this.querySelector('[data-cta-text]');
      this.plans = Array.prototype.slice.call(this.querySelectorAll('input[name="q-plan"]'));

      /* El input de cantidad solo es visible cuando no hay JS: con los tramos
         andando seria un segundo control para lo mismo. */
      var fallback = this.querySelector('.q-pb__qty-fallback');
      if (fallback && this.tiers.length) fallback.hidden = true;

      this.tiers.forEach(function (b) {
        b.addEventListener('click', function () { this.pickTier(b); }.bind(this));
      }, this);

      this.plans.forEach(function (r) {
        r.addEventListener('change', function () { this.sync(); }.bind(this));
      }, this);

      /* Si venimos de volver del alta de email, el tramo elegido antes de
         enviar le gana al que trae el HTML. */
      var guardado = null;
      try {
        guardado = sessionStorage.getItem('q-perk-tier');
        if (guardado) sessionStorage.removeItem('q-perk-tier');
      } catch (e) { /* sin sessionStorage se sigue con el tramo por defecto */ }

      var vuelto = guardado
        ? this.tiers.filter(function (b) { return b.getAttribute('data-qty') === guardado; })[0]
        : null;

      var first = vuelto
        || this.tiers.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0];
      if (first) this.pickTier(first); else this.sync();
    }

    pickTier(btn) {
      this.tiers.forEach(function (o) {
        o.setAttribute('aria-pressed', o === btn ? 'true' : 'false');
      });
      if (this.input) this.input.value = btn.getAttribute('data-qty') || '1';
      this.pct = parseInt(btn.getAttribute('data-pct'), 10) || 0;
      this.sync();
    }

    sync() {
      var sub = this.plans.filter(function (r) { return r.checked; })[0];
      var isSub = sub && sub.value === 'sub';

      if (this.freq) this.freq.hidden = !isSub;
      if (this.note) this.note.hidden = !isSub;

      if (!this.cta) return;
      var qty = parseInt((this.input && this.input.value) || '1', 10) || 1;
      var unit = parseInt(this.cta.getAttribute(isSub ? 'data-unit-sub' : 'data-unit'), 10);
      var label = this.cta.getAttribute(isSub ? 'data-sub' : 'data-add') || '';
      var fmt = this.cta.getAttribute('data-fmt');
      if (isNaN(unit)) return;

      /* El descuento por cantidad NO se aplica sobre el precio de suscripcion:
         en el admin son dos promociones distintas y la de cantidad esta atada
         al producto suelto. Si algun dia se combinan, este es el unico lugar
         donde hay que tocarlo. */
      var pct = isSub ? 0 : (this.pct || 0);
      var bruto = unit * qty;
      /* Math.round y no floor: es como redondea Shopify el monto del
         descuento, y un centavo de diferencia entre la pagina y el checkout
         es exactamente el tipo de error que nadie perdona. */
      var neto = pct > 0 ? Math.round(bruto * (100 - pct) / 100) : bruto;

      this.cta.textContent = label + ' — ' + money(neto, fmt);

      if (!this.deal) return;
      this.deal.hidden = false;
      if (this.dealNow) this.dealNow.textContent = money(neto, fmt);
      if (this.dealWas) {
        this.dealWas.hidden = neto >= bruto;
        this.dealWas.textContent = money(bruto, fmt);
      }
      if (this.dealUnit) {
        /* Precio por bolsa: es el numero que deja comparar un tramo con otro.
           Sin el, "2 bolsas a 45,58" no dice nada al lado de "1 a 23,99". */
        this.dealUnit.textContent = qty > 1
          ? money(Math.round(neto / qty), fmt) + (this.dealUnit.getAttribute('data-suffix') || '')
          : '';
      }
      if (this.dealSave) {
        this.dealSave.hidden = neto >= bruto;
        this.dealSave.textContent = (this.dealSave.getAttribute('data-prefix') || '')
          + money(bruto - neto, fmt)
          + ' (' + pct + '%)';
      }

      this.pintarNudge(qty, pct, unit, fmt);
    }

    /* Busca el primer tramo que descuente MAS que el elegido y arma el
       empujon con sus numeros. Si no hay ninguno —o sea, ya esta en el mejor
       tramo— el cartel se apaga: no hay nada mejor que ofrecerle. */
    pintarNudge(qty, pct, unit, fmt) {
      if (!this.nudge) return;

      var mejor = null;
      this.tiers.forEach(function (t) {
        var p = parseInt(t.getAttribute('data-pct'), 10) || 0;
        var q = parseInt(t.getAttribute('data-qty'), 10) || 1;
        if (p <= pct || q <= qty) return;
        if (!mejor || q < mejor.q) mejor = { q: q, p: p };
      });

      if (!mejor) {
        this.nudge.hidden = true;
        return;
      }

      var brutoMejor = unit * mejor.q;
      var ahorro = brutoMejor - Math.round(brutoMejor * (100 - mejor.p) / 100);
      var faltan = mejor.q - qty;

      this.nudge.hidden = false;
      this.nudge.textContent = (this.nudge.getAttribute('data-template') || '')
        .replace('{qty}', faltan)
        .replace('{pct}', mejor.p)
        .replace('{save}', money(ahorro, fmt));
    }
  });

  /* El custom element <q-perk> vivia aca. Se mudo a q-perk.js porque el
     footer y la seccion Newsletter tambien lo usan y no tienen por que
     cargar toda la logica de tramos de este archivo. Esta seccion lo carga
     igual: ver los <script> del tope de product-buy.liquid.

     Lo unico que quedo de aquel acople es la clave de sessionStorage
     'q-perk-tier': q-perk la escribe antes de que el submit nativo recargue
     la pagina y q-buybox la lee mas arriba, en connectedCallback, para
     reponer el tramo elegido. */

  /* OJO con el nombre: 'q-tabs' ya lo usa el FAQ (q-tabs.js). Definir dos veces
     el mismo custom element hace que gane el primero en cargar y el segundo se
     descarte en silencio; en la pagina de producto eso dejaba al FAQ con la
     implementacion de aca y las respuestas no cambiaban. Un custom element es
     un nombre global del documento: prefijar por seccion no es opcional. */
  if (!customElements.get('q-pb-tabs')) customElements.define('q-pb-tabs', class extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-tab]'));
      this.panels = Array.prototype.slice.call(this.querySelectorAll('[data-panel]'));
      if (!this.tabs.length) return;
      this.setAttribute('data-enhanced', 'true');

      this.tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { this.show(t.getAttribute('data-tab')); }.bind(this));
        t.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          var n = this.tabs[(i + d + this.tabs.length) % this.tabs.length];
          n.focus();
          this.show(n.getAttribute('data-tab'));
        }.bind(this));
      }, this);

      var on = this.tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0];
      this.show((on || this.tabs[0]).getAttribute('data-tab'));
    }

    show(key) {
      this.tabs.forEach(function (t) {
        var is = t.getAttribute('data-tab') === key;
        t.setAttribute('aria-selected', is ? 'true' : 'false');
        t.setAttribute('tabindex', is ? '0' : '-1');
      });
      this.panels.forEach(function (p) {
        p.hidden = p.getAttribute('data-panel') !== key;
      });
    }
  });
})();
